<template>
  <div>
    <!-- QFM查詢 -->
    <CCard>
      <CCardBody>
        <SearchBar
          :finishInvalidCount="finishInvalidCount"
          @doSearchEvent="doSearchEvent"
        ></SearchBar>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardBody>
        <div class="table-container">
          <vue-bootstrap4-table
            ref="qfmSearchBs4Table"
            class=""
            :rows="rows"
            :columns="columns"
            @on-change-query="onChangeQuery"
            :total-rows="totalCount"
            :config="config"
            :classes="classes"
          >
            <template v-if="isTw" slot="empty-results"> 查無結果 </template>
            <template v-if="isTw" slot="pagination-info" slot-scope="props">
              {{ paginationInfoTwText(props) }}
            </template>
            <template slot="reviewId" slot-scope="props">
              <span v-if="props.row.reviewId === 3">{{
                i18n("QFM_Vue.Manufacturer")
              }}</span>
              <span v-if="props.row.reviewId === 5">{{
                i18n("QFM_Vue.Quality")
              }}</span>
              <span v-if="props.row.reviewId === 7">{{
                i18n("QFM_Vue.Reject")
              }}</span>
              <span v-if="props.row.reviewId === 9">{{
                i18n("QFM_Vue.Close")
              }}</span>
            </template>
            <template slot="func" slot-scope="props">
              <!-- 修改廠商 -->
              <button
                class="btn btn-sm btn-success mr-2"
                data-toggle="modal"
                data-target="#addVendorModal-QM"
                @click="rmbQfmNo(props.row)"
                v-if="
                  $userInfo.userType === 'Employee' && props.row.reviewId === 3
                "
              >
                {{ $t("Buttons.EditVendor") }}
              </button>
              <!-- 回覆 -->
              <button
                class="btn btn-sm btn-success mr-2"
                @click="detail('reply', props.row)"
                v-if="
                  $userInfo.userType === 'Member' &&
                  (props.row.reviewId === 3 || props.row.reviewId === 7)
                "
              >
                {{ i18n("Buttons.Reply") }}
              </button>
              <!-- 審核 -->
              <button
                class="btn btn-sm btn-success mr-2"
                @click="detail('review', props.row)"
                v-if="
                  $userInfo.userType === 'Employee' && props.row.reviewId === 5
                "
              >
                {{ i18n("Buttons.Review") }}
              </button>
              <!-- 詳細資訊 -->
              <button
                class="btn btn-sm btn-info mr-2"
                @click="detail('watch', props.row)"
              >
                {{ i18n("Buttons.DetailInfo") }}
              </button>
              <!-- 刪除 -->
              <button
                class="btn btn-sm btn-danger"
                @click="deleteRowModal(props.row)"
                v-if="isQmManager && props.row.reviewId !== 9"
              >
                {{ $t("Buttons.Delete") }}
              </button>
              <!-- 改回廠商回覆中 -->
              <!-- <button
                class="btn btn-sm btn-danger"
                @click="rowStatus(props.row.id)"
              >
                改狀態
              </button> -->
            </template>
          </vue-bootstrap4-table>
        </div>
      </CCardBody>
    </CCard>

    <!-- 新增廠商挑選區塊 -->
    <PersonSelect
      @updateVendors="updateVendors"
      :factoryId="this.$userInfo.factoryId"
      :vendorList="rows.vendorId"
      :vendorType="'-QM'"
      :rowQfmId="rowQfmId"
    />
  </div>
</template>
<script>
import { Notification } from "element-ui";
import SearchBar from "./SearchBar";
import { qualityMixin } from "@/mixin/quality";
import PersonSelect from "./PersonSelect.vue";
import { mapGetters } from "vuex";
export default {
  mixins: [qualityMixin],
  components: {
    SearchBar,
    PersonSelect,
  },
  data() {
    return {
      rows: [],
      totalCount: 0,
      filter: { pageSize: 10, pageIndex: 1 },
      qfmQueryParam: {},
      columns: [
        {
          label: this.i18n("QFM_Vue.FactoryType"),
          name: "factory",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Supplier"),
          name: "cusAbbreviation",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.StartDate"),
          name: "startDate",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.QFMNo"),
          name: "qfmNo",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.MaterialNo"),
          name: "materialNo",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.MaterialDescription"),
          name: "materialComment",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.OrderNo"),
          name: "poNo",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Seq"),
          name: "seq",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.OrderQuantity"),
          name: "orderQuantity",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.ProduceDate"),
          name: "produceDate",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Score"),
          name: "score",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Status"),
          name: "reviewId",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Function"),
          name: "func",
          row_text_alignment: "text-center",
        },
      ],
      config: {
        card_mode: false,
        show_refresh_button: false,
        show_reset_button: false,
        // server_mode: true, // by default false
        per_page: 10, // default 10
        per_page_options: [10, 25, 50],
        global_search: {
          visibility: false,
        },
      },
      classes: {},

      finishInvalidCount: 0,

      isQmManager: false, // 是否為品質管理者(主管)

      rowQfmId: null,
    };
  },
  watch: {
    lang: function () {
      this.columns = [
        {
          label: this.i18n("QFM_Vue.FactoryType"),
          name: "factory",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Supplier"),
          name: "cusAbbreviation",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.StartDate"),
          name: "startDate",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.QFMNo"),
          name: "qfmNo",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.MaterialNo"),
          name: "materialNo",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.MaterialDescription"),
          name: "materialComment",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.OrderNo"),
          name: "poNo",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Seq"),
          name: "seq",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.OrderQuantity"),
          name: "orderQuantity",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.ProduceDate"),
          name: "produceDate",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Score"),
          name: "score",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Status"),
          name: "reviewId",
          row_text_alignment: "text-center",
        },
        {
          label: this.i18n("QFM_Vue.Function"),
          name: "func",
          row_text_alignment: "text-center",
        },
        ,
      ];
    },
  },
  methods: {
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    // 改回廠商回覆中
    rowStatus(id) {
      const vm = this;
      const api = `${this.$baseApiUrl}/QFM/ResetQFMMaster/${id}`;

      this.axios.get(api).then((response) => {
        console.log("QFM Detail", response);
      });
    },

    // 查詢 QFM Api
    doSearchEvent(val) {
      if (this.$refs.qfmSearchBs4Table) {
        this.$refs.qfmSearchBs4Table.page = 1;
      }

      const $fixDate = this.fixDate;
      const vm = this;
      const api = `${this.$baseApiUrl}/QFM/QFMMaster`;
      let params = { ...val };

      this.updateLoading(true);

      this.axios.get(api, { params }).then((response) => {
        // console.log("QFM列表", response);

        if (response.status === 200) {
          this.updateLoading(false);
          if (response.data.errorMessage) {
            Notification({
              title: "失敗",
              message: response.data.errorMessage,
              type: "error",
              duration: 5000,
            });
          } else {
            // vm.rows = response.data;
            vm.rows = response.data.map((item) => {
              let vendorId = item.vendorId;
              let startDate = $fixDate(item.startDate);
              let produceDate = $fixDate(item.produceDate);
              return {
                ...item,
                produceDate: produceDate,
                startDate: startDate,
                vendorId: vendorId,
              };
            });
            vm.totalCount = vm.rows.length;
            this.setCacheQueryParam("QfmUpload_QueryParam", val);
            vm.qfmQueryParam = val;
          }
        }
      });
    },

    // 詳細資訊
    detail(status, row) {
      // console.log(status, row);
      sessionStorage.setItem("QFM_Id", row.id);

      this.$router.push({
        path: "/qfmedit",
        query: { formStatus: status },
      });
    },

    // 主管刪除 Modal
    deleteRowModal(item) {
      const vm = this;
      this.$confirm("此操作將永久刪除該筆資料，是否繼續？", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        vm.deleteRow(item.id);
      });
    },

    // 主管刪除 Api
    deleteRow(id) {
      const vm = this;
      const url = `${this.$baseApiUrl}/QFM/DeleteQFM`;
      const param = { id: id };

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        // console.log(response);
        const { status, statusMessage } = response.data;
        this.updateLoading(false);
        if (status) {
          this.$alert(statusMessage, "警告", { type: "warning" });
        } else {
          //--成功
          Notification({
            title: "成功",
            message: "刪除成功",
            type: "success",
            duration: 5000,
          });

          let searchParam = {};
          vm.getCacheQueryParam("QfmUpload_QueryParam", searchParam);
          vm.doSearchEvent(searchParam);
        }
      });
    },

    ///////////////////////////////   修改廠商   ///////////////////////////////
    // 存 QFM 單號
    rmbQfmNo(row) {
      this.rowQfmId = row.id;
    },
    updateVendors() {
      // console.log(this.qfmQueryParam);
      this.doSearchEvent(this.qfmQueryParam);
    },

    // 分頁搜尋
    onChangeQuery(queryParams) {
      console.log("queryParams", queryParams);
      // let search = this.qfmQueryParam;
      // search.pageSize = queryParams.per_page;
      // search.pageIndex = queryParams.page;
      // //須用此方式提供 語系對應功能函數
      // search.func = (key) => this.$t(key);
      // search.fixDate = this.fixDate;
      // this.doSearchEvent(search);
    },

    // 分頁中文資訊
    paginationInfoTwText(props) {
      const vm = this;
      let page = vm.$refs.qfmSearchBs4Table.page;
      let pageCount = vm.$refs.qfmSearchBs4Table.per_page;

      let startRecNo = 0;
      let endRecNo = 0;

      if (vm.totalCount && vm.totalCount > 0) {
        startRecNo = 1 + (page - 1) * pageCount;
        endRecNo = startRecNo + pageCount - 1;
        if (endRecNo > vm.totalCount) {
          endRecNo = vm.totalCount;
        }
        return `第 ${startRecNo}筆 ~ 第 ${endRecNo}筆資料列(共${props.originalRowsLength}筆)`;
      } else {
        return "無任何資料列";
      }
    },
  },
  computed: {
    ...mapGetters(["lang"]),
  },
  mounted() {
    console.log("roleId", this.$userInfo.roleId);
    this.isQmManager = this.$userInfo.roleId === "品質管理者" ? true : false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/select.scss";

table th:first-child {
  text-align: center;
  padding: 15px 5px;
}

.table tr:nth-child(even) {
  background-color: transparent;
}

.table th {
  background-color: #303c50;
  color: #fff;
}

.btn-edit {
  background-color: #343b55;
  color: white;
}

.search-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  p {
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 0;
  }

  .el-input {
    // max-width: 350px;
    flex: 1;

    ::v-deep .el-input__inner {
      height: 34px;
      line-height: 34px;
    }
  }

  .el-select {
    flex: 1;

    ::v-deep .el-input__inner {
      height: 34px;
      line-height: 34px;
    }

    ::v-deep .el-input__icon {
      line-height: 34px;
    }
  }

  .el-radio-group {
    label {
      margin-bottom: 0;
    }
  }
}

.btn-blue {
  color: #fff !important;
  font-size: 0.85em;
  background: #343b55;
  border-radius: 6px;
}

.btn-yellow {
  background: #cca836;
  color: #fff;
}

.right {
  display: block;
  text-align: right;
}

.filter-btn-wrap {
  margin-top: 24px;
}

.option {
  margin-left: 0.2rem;
  cursor: pointer;
}
.item_list {
  margin-bottom: 5px;
}
.item-select #left-item .item-list .item,
.item-select #right-item .item-list .item {
  display: flex;
  align-items: center;
}
.item-select #left-item .item-list .item input[type="checkbox"],
.item-select #right-item .item-list .item input[type="checkbox"] {
  display: block;
  margin-right: 0.5rem;
}

.filter-block .filter-btn-wrap .btn {
  line-height: auto;
}

.filter-block .filter-field .flex > .age-input,
.filter-block .filter-field .flex > .year-input {
  width: 50px;
}

.white-overlay {
  background-color: rgba(0, 255, 255, 0.3);
}

.btn-gray {
  background-color: gray;
  color: white;
}

.item-select #right-item {
  padding-top: 55px;
}

.item-select #right-item .item-type {
  top: 33px;
}
</style>